import { Component, EventEmitter, Input, Output } from '@angular/core';
import {WizardPage} from '@workflow/components/navigator/wizard-view/interfaces';

export interface IWizardMissingValueData {
	key: string;
	title: string;
	enabled?: boolean;
}

@Component({
	selector: 'workflow-wizard-missing-value-button',
	templateUrl: './wizard-missing-value-button.component.html',
	styleUrls: [
		'./wizard-missing-value-button.component.scss',
		'../wizard-view/wizard-view.component.scss',
	]
})
export class WizardMissingValueButtonComponent {
	@Input() finishedAndLocked = false;
	@Input() showOnlyIndicator = false;
	@Input() disabled: boolean;
	@Output() fehlwertAdded = new EventEmitter<boolean>();
	@Output() status = new EventEmitter<boolean>();

	_page: WizardPage = null;
	@Input() set page(page: WizardPage) {
		this._page = page;
		this.showMenu = false;

		this.updateMissingKeys();
	}

	public hasAnyMissingValue;
	public missingKeyEntries: IWizardMissingValueData[] = [];
	public showMenu = false;

	constructor() {
		this.hasAnyMissingValue = false;
	}

	private updateMissingKeys(): void {
		if (this._page.missingValueKey) {
			this.missingKeyEntries = [{key: this._page.missingValueKey, title: this._page?.question?.title || this._page.title}];
		} else if (this._page.missingValueKeys) {
			this.missingKeyEntries = [...this._page.missingValueKeys];
		} else if (this._page.missingValueKeyGroup) {
			this.missingKeyEntries = [{key: this._page.missingValueKeyGroup, title: this._page?.question?.title || this._page.title}];
		} else {
			this.missingKeyEntries = [];
		}
	}

	toggleMenu(): void {
		this.showMenu = !this.showMenu;
	}


	updateMenu(entry: IWizardMissingValueData, $event: boolean): void {
		const entryEnabledCopy = entry.enabled;
		entry.enabled = $event;

		this.hasAnyMissingValue = !!this.missingKeyEntries.find(e => e.enabled);
		this.status.emit(this.hasAnyMissingValue);

		if ($event && entryEnabledCopy === false) { // EventEmitter nicht ansteuern, wenn Werte initialisiert werden
			this.fehlwertAdded.emit(true);
		}
	}

}
